import { useTranslation } from "react-i18next";
import { Button } from "./ui/Button";

/**
 * The host screens' failure banner, with a Refresh button, or a Dismiss
 * button when `onDismiss` is given. A teacher whose screen silently stops
 * responding cannot tell a stuck class from a slow one, so every host
 * screen that sends to the server shows its errors here.
 */
export function HostErrorBanner({
  message,
  onDismiss,
}: {
  message: string;
  onDismiss?: () => void;
}) {
  const { t } = useTranslation();
  return (
    <div
      role="alert"
      className="mb-6 bg-brand-bad/15 ring-1 ring-brand-bad/40 text-brand-bad rounded-xl px-4 py-3 flex items-center justify-between gap-3"
    >
      <div className="font-semibold">{message}</div>
      {onDismiss ? (
        <Button variant="danger" size="sm" onClick={onDismiss}>
          {t("host.errors.dismiss")}
        </Button>
      ) : (
        <Button variant="danger" size="sm" onClick={() => window.location.reload()}>
          {t("host.errors.refresh")}
        </Button>
      )}
    </div>
  );
}
